import React from "react";
import GUSCO from "../assets/images/gusco.png";

// แถบโลโก้ GUSCO + ชื่อบริษัท มุมบนซ้ายของ sidebar ใช้ร่วมกันทุก navbar
// company มาจาก localStorage "cm-company" (ใช้แค่ name)
export default function SidebarBrand({ company, href, fallbackName }) {
  const name = company?.name || fallbackName || "-";

  return (
    <a
      href={href}
      title={name}
      className="sidebar-brand position-fixed wpx-260 sidebar-dark d-flex align-items-center gap-2 px-3 text-decoration-none"
    >
      <div className="sidebar-brand-logo flex-shrink-0">
        <img src={GUSCO} alt="GUSCO" />
      </div>
      <div className="flex-grow-1 overflow-hidden">
        <div className="sidebar-brand-name text-white fw-bold text-truncate">{name}</div>
        <div className="sidebar-brand-meta">version {global.version}</div>
      </div>
    </a>
  );
}
